export default __webpack_public_path__ + "static/media/SCDream-Light.1e55b771.otf";